import { Formik } from "formik";
import {useCallback, useMemo, useState} from "react";
import { Form, Button, Typography, Input, Upload } from "antd";

import {FormItem, RadioGroup, SelectSearch} from "components";
import {ADD_ISSUE_FORMIK, BATTERY_FIRMWARE, ORGANIZATION_FIRMWARE} from "utils/formik-data";
import {BatteryValues, OrganizationValues} from "types/formik";
import { SelectType } from "types";
import {addBattery, addOrganization, setModalName} from "store/actions";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../store";
import PhoneInput from "react-phone-input-2";
import {dialCodePrefix} from "../../utils/helpers";
import { Country, State, City, ICountry, IState, ICity } from "country-state-city";


const { Title, Text } = Typography;

export default function AddOrganizationForm() {
    const dispatch = useDispatch();
    const initialValues = useMemo(() => {
        return ORGANIZATION_FIRMWARE.initialValues
    }, []);
    const {
        common: { userType =1 },
    } = useSelector<AppState, AppState>((state) => state);
    const clinetType = [{label: "B2B", value: 1},{label: "B2C", value: 2}]
    const [business, setBusiness] = useState(1);
    const orgType = [
        {
            label: "Fleet Owner",
            value: "FLEET_OWNER"
        },
        {
            label: "Fleet Client",
            value: "FLEET_CLIENT"
        },
    ];

    var filerOrg = orgType.filter(or => {
        console.log("userType : ", userType,  userType != 1);
        if (userType != 1) {
            return or.value != "FLEET_OWNER"
        }
        return or

    })


    const onCancels = useCallback(() => {
        dispatch(setModalName(undefined));
    }, [dispatch]);

    const onSubmit = useCallback(
        (values: OrganizationValues) => {
            console.log("organization Values :  ", values)
            console.log("phone : ", dialCodePrefix(values.phone_number || "", "+"))
            dispatch(
                addOrganization({
                    name: values.name || "",
                    street_address: values.street_address,
                    city: values.city || "",
                    state: values.state || "",
                    country: values.country || "",
                    org_type: values.org_type || "",
                    business_type: values.business_type || 1,
                    email: values.email || "",
                    phone_number: dialCodePrefix(values.phone_number || "", "+"),
                    national_id: values.national_id || "",
                })
            );
            onCancels();
        },
        [dispatch, onCancels]
    );

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={ORGANIZATION_FIRMWARE.validationSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({
                  setFieldValue,
                  dirty,
                  isValid,
                  handleSubmit,
                  handleChange,
                  values,
                  errors,
              }) => (
                <div className="form-container">
                    <Title level={5}>Add Client</Title>
                    <Text className="description" type="secondary">
                    Please provide the following details to add new client
                    </Text>
                    <br />
                    <Form className="--add-vehicles-form" onFinish={handleSubmit}>
                        <div className="form-fields-section">
                             <div className="form-field-wrapper">
                            <FormItem
                                verticalAlign="flex-start"
                                error={errors.business_type}
                                label="Type"
                                required
                            >
                                <RadioGroup
                                    options={clinetType}
                                    value={values.business_type || 1}
                                    onChange={(selected) => {
                                        console.log("current value : ", values.business_type)
                                        setFieldValue("business_type", selected.target.value);setBusiness(selected.target.value);
                                    }}
                                />
                            </FormItem>
                            </div>
                        <div className="form-field-wrapper">
                            <FormItem 
                            label={values.business_type === 1 ? "Client Name" : "Full Name"} 
                            error={errors.name} 
                            required
                        >
                            <Input
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                                placeholder={values.business_type === 1 ? "Client Name" : "Full Name"}
                            />
                        </FormItem>
                        </div>
                        <div className="form-field-wrapper">
                            <FormItem label="Street Address" error={errors.street_address} required>
                                <Input
                                    name="street_address"
                                    value={values.street_address}
                                    onChange={handleChange}
                                    placeholder="Street Address"
                                />
                            </FormItem>
                        </div>
                        <div className="form-field-wrapper">
                     <FormItem label="Country" error={errors.country} required>
                      <SelectSearch
                         isMultiple={false}
                         value={values.country || ""}
                         items={Country.getAllCountries().map((c: ICountry) => ({
                         label: c.name,   // show full name
                         value: c.name,   // save full name in DB
                                }))}
                         setFieldValue={setFieldValue}
                         fieldName="country"
                         placeholder="Select Country"
                         onChangeProp={(value) => {
                         setFieldValue("country", value);
                         setFieldValue("state", ""); // reset state
                         setFieldValue("city", "");  // reset city
          }}
                          />
                    </FormItem>
</div>
<div className="form-field-wrapper">
                    <FormItem label="Province" error={errors.state} required>
                      <SelectSearch
                      isMultiple={false}
                      value={values.state || ""}
                      items={
                      values.country
                     ? State.getStatesOfCountry(
                     Country.getAllCountries().find(c => c.name === values.country)?.isoCode || ""
                       ).map((s: IState) => ({
                     label: s.name,   // show full name
                    value: s.name,   // save full name
               }))
                 : []
                  }
                 setFieldValue={setFieldValue}
                  fieldName="state"
                 placeholder="Select Province"
                 onChangeProp={(value) => {
                 setFieldValue("state", value);
                 setFieldValue("city", ""); // reset city
                 }}
                 disabled={!values.country}
                  />
                </FormItem>
                </div>
                <div className="form-field-wrapper">
                                <FormItem label="City" error={errors.city} required>
                                <SelectSearch
                                    isMultiple={false}
                                    value={values.city || ""}
                                    items={
                                    values.country && values.state
                                        ? City.getCitiesOfState(
                                            Country.getAllCountries().find(c => c.name === values.country)?.isoCode || "",
                                            State.getStatesOfCountry(
                                            Country.getAllCountries().find(c => c.name === values.country)?.isoCode || ""
                                            ).find(s => s.name === values.state)?.isoCode || ""
                                        ).map((c: ICity) => ({
                                            label: c.name,   // show full name
                                            value: c.name,   // save full name
                                        }))
                                        : []
                                    }
                                    setFieldValue={setFieldValue}
                                    fieldName="city"
                                    placeholder="Select City"
                                    onChangeProp={(value) => {
                                    setFieldValue("city", value);
                                    }}
                                    disabled={!values.state}
                                />
                                </FormItem>
</div>


                            {business == 1 &&
                            <div className="form-field-wrapper">
                            <FormItem label="Organization Type" error={errors.org_type} required>
                                <SelectSearch
                                    isMultiple={false}
                                    value={values.org_type || ""}
                                    items={filerOrg}
                                    setFieldValue={setFieldValue}
                                    fieldName="org_type"
                                    placeholder="Select"
                                    onChangeProp={(value) => {
                                        setFieldValue("org_type", value);
                                    }}
                                />
                            </FormItem>
                            </div>
                            }
                            {business == 2 &&
                                <>
                              <div className="form-field-wrapper">
                                    <FormItem label="Email" error={errors.email} required>
                                        <Input
                                            name="email"
                                            value={values.email}
                                            onChange={handleChange}
                                            placeholder="Email"
                                        />
                                    </FormItem>
                                    </div>
                                    <div className="form-field-wrapper">
                                    <FormItem label="National ID" error={errors.national_id} required>
                                        <Input
                                            name="national_id"
                                            value={values.national_id}
                                            onChange={handleChange}
                                            placeholder="National ID"
                                        />
                                    </FormItem>
                                    </div>
                                    {/*<FormItem label="Phone Number" error={errors.phone_number} required>*/}
                                    {/*    <Input*/}
                                    {/*        name="phone_number"*/}
                                    {/*        value={values.phone_number}*/}
                                    {/*        onChange={handleChange}*/}
                                    {/*        placeholder="Phone Number"*/}
                                    {/*    />*/}
                                    {/*</FormItem>*/}
                                   <div className="form-field-wrapper">
                                    <FormItem label="Phone Number" error={errors.phone_number} required>
                                        <PhoneInput
                                            country="pk"
                                            inputProps={{
                                                required: true,
                                                autoFocus: true,
                                                name: "phone_no",
                                            }}
                                            inputClass="login-phone-input --user"
                                            buttonClass="user-flag"
                                            placeholder="12345678"
                                            value={values.phone_number}
                                            onChange={(val, data: { dialCode: string }) => {
                                                setFieldValue("dial_code", data.dialCode);
                                                setFieldValue("phone_number", val);
                                            }}
                                        />
                                    </FormItem>
                                    </div>
                                </>
                            }
                     
                        </div>
                        <div className="action-btn-container">
                            <>
                                <Button className="cancel-btn" onClick={onCancels}>
                                    Cancel
                                </Button>
                                <Button
                                    htmlType="submit"
                                    type="primary"
                                    disabled={(!isValid && dirty)}
                                >
                                    Save
                                </Button>
                            </>
                        </div>
                    </Form>
                </div>
            )}
        </Formik>
    );
}